import React, {useContext, useEffect, useState} from "react";
import styles from './dateAndTimeFilterPicker/DateAndTimeFilterPicker.module.scss';
import DateSelectionContainer from "./dateAndTimeFilterPicker/DateSelectionContainer";
import Button from "../../../../Componnets/Button/Button";
import appContext from "../../../../../context/appContext";
import http from "../../../../../services/api/utilities/http";

const DateAndTimeFilterPicker = ({ title, handleSubmit, handleSubmitFilters, selectedItems }) => {

  const [isTimestamp, setIsTimestamp] = useState(null);
  const [defaultData, setDefaultData] = useState(null);
  const [filteredData, setFilteredData] = useState();
  const [enableContainer, setEnableContainer] = useState({
    startDate: true,
    endDate: false
  });

  const context = useContext(appContext);

  const submitValidFilters = (data) => {
    if (!data || !Array.isArray(data.dateToPass)) {
      return;
    }

    const dateToPass = data.dateToPass.filter(item => !Array.isArray(item?.value) || item.value.length > 0);

    // An explicit empty dateToPass list is used when the user disables the
    // section and must still be submitted. A list that only contained
    // `value: []`, however, is an incomplete editor state and must not clear
    // the already selected filters.
    if (data.dateToPass.length > 0 && dateToPass.length === 0) {
      return;
    }

    handleSubmitFilters({...data, dateToPass});
  }

  const getAvailableAttributes = () => {
    http.get('process_mining/get_attributes/' + context.handleUid().id)
      .then(res => {
        if (res.data.data.columns["TIMESTAMP"]) {
          setIsTimestamp(true);
        } else {
          setIsTimestamp(false);
        }
      })
      .catch(err=>{
        console.log(err.response);
      })
  }

  useEffect(() => {
    getAvailableAttributes();
  }, []);


  useEffect(() => {
    if (isTimestamp !== null) {
      if (isTimestamp === false) {
        setDefaultData({
          dateToPass: [
            {
              column: ["STARTTIME"],
              value: null,
              is_active: true,
            },
          ],
        })
      } else {
        setDefaultData({
          dateToPass: [
            {
              column: ["TIMESTAMP"],
              value: null,
              is_active: true,
            },
          ],
        });
      }
    }
  }, [isTimestamp]);

  useEffect(() => {
    // On mount, `enableContainer` runs before the saved filters have been
    // copied into `filteredData`. Do not create and submit an empty default
    // filter during that hydration window, otherwise returning to this menu
    // overwrites the user's saved date range.
    if (isTimestamp === null || filteredData === undefined) {
      return;
    }

    if (defaultData && defaultData.dateToPass.length) {
      let t = {};
      if (enableContainer.endDate) {
        if (isTimestamp === false) {
          t = {
            dateToPass: [
              ...filteredData.dateToPass,
              {
                column: ["ENDTIME"],
                value: null,
                is_active: true,
              }
            ]
          }
        } else {
          t = {
            dateToPass: [
              ...filteredData.dateToPass,
              {
                column: ["TIMESTAMP"],
                value: null,
                is_active: true,
              }
            ]
          }
        }
      } else {
        t = {
          dateToPass: [
            ...filteredData.dateToPass.filter(item => item.column[0] !== "ENDTIME")
          ]
        }
      }
      submitValidFilters(t);
      setFilteredData(t);
    }

    if (!enableContainer.startDate && filteredData?.dateToPass?.length === 1 && (filteredData?.dateToPass[0]?.column[0] === "STARTTIME" || filteredData?.dateToPass[0]?.column[0] === "TIMESTAMP")) {
      setDefaultData(null)
      setFilteredData({dateToPass: []})
      submitValidFilters({dateToPass: []})
    }
    if (enableContainer.startDate && !filteredData?.dateToPass?.length) {
      let t
      if (isTimestamp === false) {
        t = {
          dateToPass: [
            {
              column: ["STARTTIME"],
              value: null,
              is_active: true,
            }
          ]
        }
      } else {
        t = {
          dateToPass: [
            {
              column: ["TIMESTAMP"],
              value: null,
              is_active: true,
            }
          ]
        }
      }
      setFilteredData(t)
      submitValidFilters(t)
    }
  }, [enableContainer]);

  useEffect(() => {
    if (defaultData) {
      if (!selectedItems.data.length) {
        submitValidFilters(defaultData);
        setFilteredData(defaultData);
      }
    }
  }, [defaultData]);

  useEffect(() => {
    if (selectedItems.data && selectedItems.data.length) {
      setFilteredData({
        dateToPass: selectedItems.data,
      });
    } else {
      setFilteredData({
        dateToPass: []
      })
    }
  }, [selectedItems])

  useEffect(() => {
    if (selectedItems.data && selectedItems.data.length && selectedItems.data.find(item => item.value && item.value.length && item.column[0] === "ENDTIME")) {
      setEnableContainer({
        ...enableContainer,
        endDate: true
      })
    }
  }, []);

  const handleTriggerEnableContainer = (type) => {
    setEnableContainer({
      ...enableContainer,
      [type]: !enableContainer[type]
    })
  }

  const handleDone = (data, type) => {
    if (data.dateToPass.length && data.dateToPass[0].value) {
      let filtered = filteredData;

      if (data.dateToPass.length && data.dateToPass[0].column[0] === "STARTTIME") {
        const nullStartTime = filteredData.dateToPass.find(item => item.column[0] === "STARTTIME" && item.value === null);
        let hasValues = filteredData.dateToPass.filter(item => item.value !== null);
        const nullEndTime = filteredData.dateToPass.filter(item => item.column[0] === "ENDTIME" && item.value === null);
        if (nullStartTime) {
          filtered = {
            dateToPass: [
              ...hasValues,
              data.dateToPass[0],
              ...nullEndTime
            ]
          }
        } else {
          const arrKeys = hasValues.map(el => el.column[0]);
          const findLastStartTimeIndex = arrKeys.lastIndexOf("STARTTIME");
          if (findLastStartTimeIndex > -1) {
            hasValues[findLastStartTimeIndex] = data.dateToPass[0];
          } else {
            hasValues[hasValues.length] = data.dateToPass[0];
          }
          filtered = {
            dateToPass: [
              ...hasValues,
              ...nullEndTime
            ]
          }
        }
      } else if (data.dateToPass.length && data.dateToPass[0].column[0] === "ENDTIME" && enableContainer.endDate) {
        const nullEndTime1 = filteredData.dateToPass.find(item => item.column[0] === "ENDTIME" && (item.value === null || (item.value && item.value[0] === null)));
        let hasValues1 = filteredData.dateToPass.filter(item => item.value !== null);
        const nullStartTime1 = filteredData.dateToPass.filter(item => item.column[0] === "STARTTIME" && item.value === null);
        if (nullEndTime1) {
          filtered = {
            dateToPass: [
              ...hasValues1,
              ...nullStartTime1,
              data.dateToPass[0],
            ]
          }
        } else {
          const arrKeys1 = hasValues1.map(el => el.column[0]);
          const findLastEndTimeIndex = arrKeys1.lastIndexOf("ENDTIME");
          if (findLastEndTimeIndex > -1) {
            hasValues1[findLastEndTimeIndex] = data.dateToPass[0];
          } else {
            hasValues1[hasValues1.length] = data.dateToPass[0];
          }
          filtered = {
            dateToPass: [
              ...nullStartTime1,
              ...hasValues1,
            ]
          }
        }
      } else if (data.dateToPass.length && data.dateToPass[0].column[0] === "TIMESTAMP") {
        const nullTimestamp = filteredData.dateToPass.find(item => item.column[0] === "TIMESTAMP" && (item.value === null || (item.value && item.value[0] === null)));
        let hasValues2 = filteredData.dateToPass.filter(item => item.value !== null);
        if (nullTimestamp > 2) {
          filtered = {
            dateToPass: [
              ...hasValues2,
              data.dateToPass[0],
            ]
          }
        } else {
          const arrKeys2 = filteredData.dateToPass.map(el => el.column[0]);
          const findLastTimestampIndex = arrKeys2.lastIndexOf("TIMESTAMP");
          let insertIndex = arrKeys2.lastIndexOf("TIMESTAMP")
          insertIndex = type === "startDate" ? insertIndex - 1 : insertIndex
          if (type === "startDate") {
            insertIndex = insertIndex % 2 === 0 ? insertIndex : insertIndex - 1
          }
          filteredData.dateToPass[insertIndex > -1 ? insertIndex : 0] = data.dateToPass[0];
          // if (findLastTimestampIndex > -1) {
          //   hasValues2[insertIndex] = data.dateToPass[0];
          // } else {
          //   hasValues2[hasValues2.length] = data.dateToPass[0];
          // }
          filtered = {
            dateToPass: [
              ...filteredData.dateToPass,
            ]
          }
        }
      }
      submitValidFilters(filtered);
    }

  }

  const handleAddMore = () => {
    if (filteredData) {
      let data = {dateToPass: [...filteredData?.dateToPass, ...defaultData?.dateToPass]};
      if (enableContainer.endDate) {
        data = {
          dateToPass: [
            ...filteredData.dateToPass,
            ...defaultData.dateToPass,
            {
              column: isTimestamp ? ["TIMESTAMP"] : ["ENDTIME"],
              value: null,
              is_active: true,
            }
          ]
        }
      }
      submitValidFilters(data);
    }
  }

  const filteredStart = filteredData && filteredData.dateToPass.slice().reverse().find(item => item.column[0] === "STARTTIME");
  const filteredEnd = filteredData && filteredData.dateToPass.slice().reverse().find(item => item.column[0] === "ENDTIME");
  let timestampFilters = filteredData && filteredData.dateToPass.slice().filter(item => item.column[0] === "TIMESTAMP")
  
  return (
    <div className={[styles.DateAndTimeFilterPicker].join(' ')}>
      <div className={styles.contentsHeader}>
        { title }
      </div>
      {
        isTimestamp !== null &&
          <div className={`${styles.mainContent}`}>
            <div>
              <DateSelectionContainer
                type={"startDate"}
                title={"Start Date Selection"}
                handleDone={(data, type) => handleDone(data, type)}
                isTimestamp={isTimestamp}
                value={ (filteredStart && filteredStart.value) || (timestampFilters && timestampFilters.length % 2 === 0
                  ? timestampFilters[timestampFilters.length - 2]?.value
                  : timestampFilters[timestampFilters.length - 1]?.value)}
                isEnableSection={enableContainer.startDate}
                handleTriggerEnableContainer={handleTriggerEnableContainer}
              />
            </div>
            <div>
              <DateSelectionContainer
                type={"endDate"}
                title={"End Date Selection"}
                handleDone={(data, type) => handleDone(data, type)}
                isTimestamp={isTimestamp}
                value={ (filteredEnd && filteredEnd.value) || (timestampFilters && timestampFilters.length % 2 === 0
                  ? timestampFilters[timestampFilters.length - 1]?.value
                  : null)}
                isEnableSection={enableContainer.endDate}
                handleTriggerEnableContainer={handleTriggerEnableContainer}
              />
            </div>
          </div>
      }
      <div className={[styles.buttons, 'd-flex'].join(' ')}>
        <div className={'mr-2'}>
          <Button
            onClick={handleAddMore}
            title={'Add More'}
            color={context?.handleLayerList().find(item => item.selected)?.color}
            type={'outline'}
            size={'block'}
            height={"medium"}
          />
        </div>
      </div>
    </div>
  )
};

export default DateAndTimeFilterPicker;
